import { SaveAlt } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import React from 'react';
import Swal from 'sweetalert2';
import { formatDateTime } from '../../../../utils/dateUtils';
import dayjs from 'dayjs';

const ExportAll = (props) => {
  const { taxData,searchType,bookingNumber,startDate,endDate,year } = props;

  // Define custom headers and their corresponding data mapping
  //  'Booking Number': row.bookingNumber,
  //                 'Customer Name': row.customerName,
  //                 'Customer Address': row.customerAddress,
  //                 'State': row.state,
  //                 'State Code': row.stateCode,
  //                 'Service Date': dayjs(row.serviceDate).format('DD-MM-YYYY'),
  //                 'Charge Type': row.chargeType,
  //                 'Service Name': row.serviceName,
  //                 'SAC Code': row.sacCode || '',
  //                 'RCM': row.rcm || '',
  //                 'Quantity': row.quantity,
  //                 'Unit Price': row.unitPrice,
  //                 'Base Amount': row.baseAmount,
  //                 'Coin Discount': row.coinDiscount,
  //                 'Coupon Discount': row.couponDiscount,
  //                 'Taxable Amount': row.taxableAmount,
  //                 'IGST': row.igst,
  //                 'CGST': row.cgst,
  //                 'SGST': row.sgst,
  //                 'Total GST': row.totalGst,
  //                 'Total Amount': row.totalAmount,
  //                 'Tax Rate': row.taxRate
  const exportMapping = [
    {
      header: 'Booking Number',
      value: (row) => `${row.bookingNumber}`
    },
    {
      header: 'Customer Name',
      value: (row) => `${row.customerName}`
    },
    {
      header: 'Customer Address',
      value: (row) => `${row.customerAddress}`
    },
    {
      header: 'State',
      value: (row) => `${row.state}`
    },
    {
      header: 'Service Name',
      value: (row) => `${row.serviceName ||''}`
    },
    // {
    //   header: 'Service Image',
    //   value: (row) => `${row.images || ''}`
    // },
    // { 
    //   header: 'Parent Service',
    //   value: (row) => `${row?.parentService?.title || ''}`
    // },
    // {
    //   header: 'Sub Category',
    //   value: (row) => row.ServiceCategoryRels[0]?.ServiceCategory?.title || ''
    // },
    // {
    //   header: 'Category',
    //   value: (row) => row.ServiceCategoryRels[0]?.ServiceCategory?.parentCategory?.title || ''
    // },
    // {
    //   header: 'Status',
    //   value: (row) => row.isActive ? 'Active' : 'Inactive'
    // },
    // {
    //   header: 'Creation Date',
    //   value: (row) => formatDateTime(row.createdAt)
    // }
  ];

  const handleExportAllRows = async () => {
    try {
      // Swal.fire({
      //   title: 'Exporting Data',
      //   text: 'Please wait while we prepare your download...',
      //   icon: 'info',
      //   allowOutsideClick: false,
      //   didOpen: () => {
      //     Swal.showLoading();
      //   }
      // });

      // Transform data using custom mapping
      const exportData = taxData.map(row => {
        return exportMapping.reduce((acc, field) => {
          acc[field.header] = field.value(row);
          return acc;
        }, {});
      });

      // Create CSV content
      const headers = exportMapping.map(field => `"${field.header}"`).join(',');
      const csvContent = exportData.map(row => 
        exportMapping.map(field => 
          `"${String(row[field.header] ?? '').replace(/"/g, '""')}"`
        ).join(',')
      );

      csvContent.unshift(headers);

      // Create and download file
      const csvString = csvContent.join('\n');
      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const fileName = searchType === 'year' 
                      ? `Tax_Report_${year}` 
                      : searchType === 'booking' 
                          ? `Tax_Report_${bookingNumber}` 
                          : `Tax_Report_${dayjs(startDate).format('DD-MM-YYYY')}_to_${dayjs(endDate).format('DD-MM-YYYY')}`;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      Swal.fire({
        title: 'Export Successful',
        html: `
          <p>If download doesn't start automatically, click on provided link:
          <a href="${url}" download="ServiceExpert-report.csv" style="color: blue; text-decoration: underline;">
            Download CSV
          </a></p>
        `,
        icon: 'success',
        showConfirmButton: true,
        confirmButtonText: 'Close'
      });

    } catch (error) {
      console.error('Export failed', error);
      
      Swal.fire({
        title: 'Export Failed',
        text: 'There was an issue exporting the data. Please try again.',
        icon: 'error'
      });
    }
  };

  return (
    <Box>        
      <Button 
        onClick={handleExportAllRows}
        startIcon={<SaveAlt />}
        sx={{textTransform:'none'}}
      >
        Export
      </Button>      
    </Box>
  );
}

export default ExportAll;